import React from 'react';
const ContactSupportSvg = ({
  color = 'white',
  className,
  onClick,
  ...props
}) => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <g id="Frame 1437253195">
        <g id="support">
          <path
            id="Vector"
            d="M1.69238 13.1846V10.2231C1.69238 5.14615 5.83854 1 11.0001 1C16.1616 1 20.3078 5.14615 20.3078 10.2231V13.1846"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M20.3077 11.1538V14.0307C20.3077 19.023 16.1615 23 11 23V21.3077H13.5385"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M5.077 17.0768V10.3076C3.21546 10.3076 1.69238 11.8307 1.69238 13.6922C1.69238 15.5538 3.21546 17.0768 5.077 17.0768Z"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M16.9233 10.3076V17.0768C18.7849 17.0768 20.308 15.5538 20.308 13.6922C20.308 11.8307 18.7849 10.3076 16.9233 10.3076Z"
            stroke={color}
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default ContactSupportSvg;
